import { useEffect, useRef } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Grain } from "@/components/site/primitives";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { ShowreelFeature } from "@/components/site/ShowreelFeature";
import { MarqueeStrip } from "@/components/site/MarqueeStrip";
import { SelectedWork } from "@/components/site/SelectedWork";
import { CurrentProjects } from "@/components/site/CurrentProjects";
import { Studio } from "@/components/site/Studio";
import { Previs } from "@/components/site/Previs";
import { Equipment } from "@/components/site/Equipment";
import { Workshops } from "@/components/site/Workshops";
import { Footer } from "@/components/site/Footer";
import { Toaster } from "@/components/ui/sonner";

export default function HomePage() {
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    lenisRef.current = lenis;

    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);

    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (!el) return;
    const top = el.getBoundingClientRect().top + window.scrollY;
    if (lenisRef.current) {
      lenisRef.current.scrollTo(top, { duration: 1.2 });
    } else {
      window.scrollTo({ top, behavior: "smooth" });
    }
  };

  return (
    <div className="App bg-background text-foreground min-h-screen">
      <Grain />
      <Toaster position="bottom-right" theme="dark" richColors />
      <Navbar onNavigate={scrollTo} />
      <main>
        <Hero onScrollCue={() => scrollTo("reel")} />
        <ShowreelFeature />
        <MarqueeStrip />
        <CurrentProjects />
        <SelectedWork />
        <Studio />
        <Previs />
        <Equipment />
        <Workshops />
        <Footer />
      </main>
    </div>
  );
}
